import { useState } from "react";

// Definindo o tipo genérico para o Installment
export interface Installment {
	clientId: string;
	client_status: string;
	count_amount: string;
	data_generate: string;
	day_due_date: string;
	document: string;
	name: string;
	sum_amount: string;
	sum_discount: string;
}

export interface HasName {
	name: string;
	// Aqui você pode adicionar outras propriedades comuns que seus tipos podem ter
  }

type ModalType = "details" | "cancel" | "convert" | "manual" | "invoice" |"generateBill" | null;

export function useInstallmentModals<T extends Installment>() {
	const [modalType, setModalType] = useState<ModalType>(null);
	const [selectedRow, setSelectedRow] = useState<T | null>(null);

	// Função para abrir o modal
	const openModal = (type: ModalType, row: T) => {
		setModalType(type);
		setSelectedRow(row);
	};

	// Função para fechar o modal
	const closeModal = () => {
		setModalType(null);
		setSelectedRow(null);
	};

	return {
		modalType,
		selectedRow,
		openModal,
		closeModal,
	};
}
